import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {ContentHomeRecommendVo} from '../../common/shared/api/nicolas/vo/ContentHomeRecommendVo.interface';

/**
 * 콘텐츠 홈 추천 정보 조회
 *
 * Origin: pageNicolasApi.getContentHomeRecommend
 * API: GET /api/v2/content/recommend
 */
export async function getContentRecommend(
  {
    seriesId,
  }: {
    seriesId: number;
  },
  options?: FetcherOptions
): Promise<ApiResultVo & {result: ContentHomeRecommendVo}> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v2/content/recommend',
    {
      method: 'GET',
      params: {
        series_id: seriesId,
      },
    },
    options
  );
  return response.data;
}
